import type {HalGeometry, HalGeometryRef} from "@cm/hal"
import {HalRef} from "@cm/hal"
import {WebGl2Geometry} from "#webgl2/webgl2-geometry"
import type {WebGl2Context} from "#webgl2/webgl2-context"
import {loggerFactory} from "@cm/browser-log"

export class WebGl2GeometryCache {
    constructor(private halContext: WebGl2Context) {}

    dispose(): void {
        if (this.usedGeometries.size > 0) {
            logger.warn("GeometryCache is being disposed with used geometries still in use. ")
        }
        this.usedGeometries.forEach((geometry) => geometry.dispose())
        this.usedGeometries.clear()
        this.freeGeometries.forEach((geometry) => geometry.dispose())
        this.freeGeometries.length = 0
    }

    getGeometry(): HalGeometryRef {
        let geometry = this.freeGeometries.pop()
        if (!geometry) {
            geometry = new WebGl2Geometry(this.halContext)
        }
        if (this.usedGeometries.has(geometry)) {
            throw new Error("Geometry is already in use")
        }
        this.usedGeometries.add(geometry)

        // reset geometry
        geometry.clear()
        geometry.conservativeRasterization = false

        return new HalRef(geometry, (geometry) => {
            if (!this.usedGeometries.has(geometry)) {
                throw new Error("Geometry is not in use")
            }
            this.usedGeometries.delete(geometry)
            this.freeGeometries.push(geometry)
        })
    }

    private usedGeometries = new Set<HalGeometry>()
    private freeGeometries: HalGeometry[] = []
}

const logger = loggerFactory.getLogger("webgl2")
